import { Grid } from "semantic-ui-react";
import PageWrap from "components/PageWrap/PageWrap";
import { useTranslation } from "react-i18next";
import LandingPage from "./LandingPage";

function MainPage() {
  const { t } = useTranslation("common");
  return (
    <PageWrap page="main" t={t}>
      <Grid columns={1} divided stackable className="page-container">
        <Grid.Row>
          <Grid.Column>
            <LandingPage t={t} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </PageWrap>
  );
}

export default MainPage;
